// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://edjgxjktktvfaypxjqcj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVkamd4amt0a3R2ZmF5cHhqcWNqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMyMjQyNzYsImV4cCI6MjA1ODgwMDI3Nn0.3ibIKjnLebHKnqHRatk-yPC0M2xvhBwByaHkDXQcnjA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);